import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { IoAlertCircleSharp, IoEye, IoEyeOff } from "react-icons/io5";
import LoadingComponent from "../Components/LoadingComponent";
import useAuth from "../useAuth";
import logo from "../assets/logo.jpg";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedPassword, setIsFocusedPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { user, authMessage, loading, loginWithEmailAndPassword } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    loginWithEmailAndPassword(email, password);
  };

  if (user) {
    if (user?.userType === "admin") return <Navigate to="/my/home" />;
  }

  return (
    <div className="flex h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900 text-white">
      {/* Left Side */}
      <div className="w-1/2 flex justify-center items-center px-10">
        <div className="space-y-6">
          <div className="ml-36 h-64 w-64 bg-white rounded-full flex justify-center items-center">
            <img src={logo} alt="logo" className="h-64 w-52 rounded-full" />
          </div>
          <h1 className="text-6xl font-extrabold text-orange-400 animate-pulse">
            AUTHENTICATION
          </h1>
          <p className="text-gray-300 text-lg">Please login to continue. </p>
        </div>
      </div>

      {/* Login Form */}
      <form
        onSubmit={handleLogin}
        className="w-1/2 flex justify-center items-center bg-slate-100 rounded-l-[4rem] shadow-lg animate-slide-from-right"
      >
        <div className="w-[400px] bg-white border text-gray-800 rounded-2xl shadow-xl p-8">
          <div className="mb-6 text-center">
            <h2 className="text-3xl font-bold text-blue-800">Login</h2>
            <p className="text-blue-500 mt-2">Please sign in to continue</p>
          </div>

          {/* Email */}
          <div className="mb-6">
            <label className="block font-semibold mb-1">Username</label>
            <input
              // type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              required
            />
          </div>

          {/* Password */}
          <div className="mb-6 relative">
            <label className="block font-semibold mb-1">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 pr-10 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onFocus={() => setIsFocusedPassword(true)}
              onBlur={() => setIsFocusedPassword(false)}
              required
            />
            <div
              className="absolute right-3 top-[38px] text-gray-600 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <IoEyeOff size={20} /> : <IoEye size={20} />}
            </div>
          </div>

          {/* Error Message */}
          {authMessage && (
            <div className="flex items-center gap-2 text-red-600 text-sm mb-4">
              <IoAlertCircleSharp size={18} />
              {authMessage?.slice(5).split("-").join(" ")}
            </div>
          )}

          {/* Submit */}
          <div className="flex justify-end">
            <button
              type="submit"
              className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full shadow transition"
            >
              LOGIN
              <BsArrowRight />
            </button>
          </div>
        </div>
      </form>

      {loading && <LoadingComponent />}
    </div>
  );
}
